import Component from '../component/component';

import './profile-menu.scss';

export default class ProfileMenu extends Component {
    static initSelector: string = '.profile-menu';

    public trigger: HTMLElement;

    constructor(target: HTMLElement) {
        super(target);

        this.trigger = this.element.querySelector('.profile-menu__header');

        this.init();
    }

    init(): void {
        this.trigger.addEventListener('click', this.toggle.bind(this));
    }

    toggle(): void {
        if (this.element.classList.contains('is-open')) {
            this.element.classList.remove('is-open');
        } else {
            this.element.classList.add('is-open');
        }
    }
}
